<template>
  <div>
    <template v-if="!onlyLocale">
      <v-combobox id="country" :label="$t('region_select_country')" v-model="country" placeholder="請選擇國家"
        item-text="countryName" item-value="countryShortCode" :items="countryRegionData" outlined
        :error="(hasInvalid && invalidError.country && country === '')"
        :error-messages="(hasInvalid && invalidError.country) ? [$t(invalidError.country)] : null" color="primary-1"
        @change="e => updateAddress('country')" />
    </template>
    <v-text-field id="postalCode"
      :label="`${$t('userinfo_postal_code')}${!!country && country !== '' && country.countryName === 'Taiwan' ? '' : `(${$t('no_postal_code_note')})`}`"
      v-model="postalCode" outlined autocomplete="off"
      :error="hasInvalid && invalidError.postalCode && postalCode === ''"
      :error-messages="hasInvalid && invalidError.postalCode ? [$t(invalidError.postalCode)] : null"
      :disabled="onlyLocale || (!!country && country !== '' && country.countryName === 'Taiwan')"
      @change="e => updateAddress('postalCode')" color="primary-1"></v-text-field>
    <!-- 國籍選擇台灣，地區可用下拉選單 -->
    <template v-if="onlyLocale || (!!country && country !== '' && country.countryName === 'Taiwan')">
      <v-select id="county" v-model="county" background-color="white" :items="Object.keys(areas)"
        :label="$t('region_select_city')" outlined :error="hasInvalid && (invalidError.county) && county === ''"
        :error-messages="hasInvalid && (invalidError.county) ? [$t(invalidError.county)] : null"
        :disabled="!onlyLocale && country === ''" @change="e => updateAddress('county')" color="primary-1" />
      <v-select id="district" v-model="district" background-color="white" :items="areas[county]" item-text="name"
        :label="$t('region_select_area')" :error="hasInvalid && (invalidError.district) && district === ''"
        :error-messages="hasInvalid && (invalidError.district) ? [$t(invalidError.district)] : null" outlined
        @change="e => updateAddress('district')" color="primary-1" />
      <v-text-field id="address" :label="$t('region_select_address')" v-model="address" outlined autocomplete="off"
        :error="hasInvalid && (invalidError.address) && address === ''"
        :error-messages="hasInvalid && (invalidError.address) ? [$t(invalidError.address)] : null"
        @blur="e => updateAddress('address')" @input="e => updateAddress('address')"
        @change="e => updateAddress('address')" color="primary-1"></v-text-field>
    </template>
    <!-- 外國，地區用文字輸入 -->
    <template v-else>
      <v-text-field id="address" :label="$t('region_select_address')" v-model="address" outlined autocomplete="off"
        :error="hasInvalid && (invalidError.address) && address === ''"
        :error-messages="hasInvalid && (invalidError.address) ? [$t(invalidError.address)] : null"
        @blur="e => updateAddress('address')" @input="e => updateAddress('address')"
        @change="e => updateAddress('address')" color="primary-1"></v-text-field>
      <v-select id="county" v-model="county" background-color="white"
        :items="!country || country === '' || (country && !country.regions) ? [] : country.regions" :item-text="'name'"
        :item-value="country && country.regions && country.regions[0].shortCode ? 'shortCode' : 'name'"
        :label="$t('region_select_city')" outlined :error="hasInvalid && (invalidError.county) && county === ''"
        :error-messages="hasInvalid && (invalidError.county) ? [$t(invalidError.county)] : null"
        :disabled="!country || country === ''" @blur="e => updateAddress('county')"
        @input="e => updateAddress('county')" @change="e => updateAddress('county')" color="primary-1" />
      <v-text-field id="district" :label="$t('region_select_area')" v-model="district" outlined autocomplete="off"
        :error="hasInvalid && (invalidError.district) && district === ''"
        :error-messages="hasInvalid && (invalidError.district) ? [$t(invalidError.district)] : null"
        @blur="e => updateAddress('district')" @input="e => updateAddress('district')"
        @change="e => updateAddress('district')" color="primary-1"></v-text-field>
    </template>
  </div>
</template>

<script>
import countryRegionData from 'country-region-data/dist/data-umd';
import twAreas from "./tw_area.js";

export default {
  props: {
    hasInvalid: {
      type: Boolean,
      default: false,
    },
    invalidError: {
      type: Object,
      default: null,
    },
    onlyLocale: {
      type: Boolean,
      default: false
    },
    propsCountry: {
      type: String,
      default: ""
    },
    propsCounty: {
      type: String,
      default: ""
    },
    propsDistrict: {
      type: String,
      default: ""
    },
    propsAddress: {
      type: String,
      default: ""
    },
    propsPostalCode: {
      type: String,
      default: ""
    }
  },
  watch: {
    propsAddress(newVal, old) {
      this.address = newVal;
    },
    propsCountry(newVal) {
      this.country = newVal !== '' ? countryRegionData.find(country => country.countryName === this.propsCountry) : newVal
      this.setCounty()
    },
    propsCounty(newVal) {
      if (!['Taiwan', 'Macao'].includes(this.country.countryName))
        this.setCounty()
      else
        this.county = newVal
    }
  },
  data() {
    return {
      country: this.propsCountry !== '' ? countryRegionData.find(country => country.countryName === this.propsCountry) : this.propsCountry,
      county: this.propsCounty || '',
      district: this.propsDistrict || '',
      address: this.propsAddress || '',
      postalCode: this.propsPostalCode || ''
    };
  },
  computed: {
    countryRegionData() {
      return countryRegionData;
    },
    areas() {
      return twAreas;
    },
    regions() {
      return this.country.regions || [];
    }
  },
  mounted() {
    this.setCounty()
    if (!this.propsCountry) {
      let hasArea = false
      if (Object.keys(this.areas).includes(this.county)) {
        this.country = this.countryRegionData.find(c => c.countryName === 'Taiwan')
        this.updateAddress('country')
      }
    }
  },
  // updated() {
  //   this.setCounty()
  // },
  methods: {
    setCounty() {
      console.log('setCounty', this.country, this.propsCounty)
      if (!!this.country && !['Taiwan', 'Macao'].includes(this.country.countryName)) {
        let selectedCounty = this.country.regions.find(r => r.name === this.propsCounty)
        this.county = selectedCounty ? selectedCounty.shortCode : ''
      } else {
        this.county = this.propsCounty || this.country.regions[0]
      }
    },
    updateAddress(name) {
      if (name === 'district' && (['Taiwan', 'Macao'].includes(this.country.countryName) || this.onlyLocale)) {
        const area = this.country.countryName === 'Taiwan' ? this.areas[this.county].find((area) => (area.name === this.district)) : null
        this.postalCode = area ? area.zip : '000';
      }

      let county = null
      if (this.country && this.country.regions) {
        if (!['Taiwan', 'Macao'].includes(this.country.countryName))
          county = this.country.regions.find(r => r.shortCode === this.county)
        else if (this.country.countryName === 'Macao')
          county = this.country.regions.find(r => r.name === this.county)
      }

      county = county ? county.name : ''

      if (this.onlyLocale) {
        this.$emit("updateAddress", {
          county: this.country.countryName === 'Taiwan' ? this.county : county,
          district: this.district,
          address: this.address,
          postalCode: this.postalCode,
        });
      } else {
        this.$emit("updateAddress", {
          country: this.country.countryName,
          county: ['Taiwan'].includes(this.country.countryName) ? this.county : county,
          district: this.district,
          address: this.address,
          postalCode: this.postalCode,
        });
      }
      this.$forceUpdate()
    }
  }
};
</script>
